import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function SettingsButton({...params}){

    const { mode } = useContext(ThemeContext);

    let settingsButtonState = params.settingsButtonState
    let setSettingsButtonState = params.setSettingsButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-settings-light-active.svg", "/icons/icons-light/icon-settings-light-default.svg", "/icons/icons-light/icon-settings-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-settings-dark-active.svg", "/icons/icons-dark/icon-settings-dark-default.svg", "/icons/icons-dark/icon-settings-dark-hover.svg"]

    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/settingspage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setSettingsButtonState('hover')
        else if (settingsButtonState !== 'active') setSettingsButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setSettingsButtonState('default')
        if (onButtonPage) setSettingsButtonState('active')
        else if (settingsButtonState !== 'active') setSettingsButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (settingsButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (settingsButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (settingsButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (settingsButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (settingsButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (settingsButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '52px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'33px'} height={'45px'} paddingBottom={'10px'}  id={"StationsButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Settings</Typography>
        </Stack>
    )
}
